<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        md12
      >
        <div>
          <material-card
            color="general"
            title="Price Rule Data"
            text="List of Price Rules for setup selling price"
          >
            <v-spacer/>
            <v-text-field
              v-model="search"
              prepend-icon="search"
              placeholder="Search"
              clearable
              single-line
              hide-details/>
            <v-dialog
              v-model="dialog"
              persistent
              max-width="720px">
              <template v-slot:activator="{ on }">
                <v-btn
                  color="general"
                  dark
                  class="mb-2"
                  v-on="on">New
                </v-btn>
              </template>
              <v-form
                id="form-vue"
                ref="form"
                v-model="valid"
                :lazy-validation="lazy"
              >
                <v-card>
                  <v-card-text>
                    <v-container grid-list-md>
                      <v-layout wrap>
                        <v-flex
                          xs12
                          sm6
                          md4>
                          <v-text-field
                            v-model="editedItem.name"
                            :rules="[rules.required]"
                            label="Name *"/>
                        </v-flex>
                        <v-flex
                          xs12
                          sm6
                          md4>
                          <v-text-field
                            v-model="editedItem.opsMultiplier"
                            :rules="[rules.required,rules.number]"
                            label="1st Formula (x) *"/>
                        </v-flex>
                        <v-flex
                          xs12
                          sm6
                          md4>
                          <v-text-field
                            v-model="editedItem.opsAddition"
                            :rules="[rules.required,rules.number]"
                            label="2nd Formula (+ -) *"/>
                        </v-flex>
                        <v-flex
                          xs12
                          sm6
                          md4>
                          <v-text-field
                            v-model="editedItem.discMax"
                            :rules="[rules.required,rules.number]"
                            append-icon="mdi-percent"
                            label="Disc Max (%) *"/>
                        </v-flex>
                        <v-flex
                          xs12
                          sm12
                          md12>
                          <v-textarea
                            v-model="editedItem.desc"
                            label="Description"
                            clearable
                          />
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer/>
                    <v-btn
                      color="red darken-1"
                      flat
                      @click="close">Cancel
                    </v-btn>
                    <v-btn
                      :disabled="!valid"
                      color="green darken-1"
                      flat
                      @click="save">Save
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-form>
            </v-dialog>

            <v-dialog
              v-model="dialogDelete"
              max-width="400px">
              <v-card>
                <v-card-title class="headline">System Message Confirmation</v-card-title>
                <v-card-text>
                  Are you sure want to remove this data? <br>
                  "{{ deleteItemRecord.name }}"
                </v-card-text>
                <v-card-actions>
                  <v-spacer/>

                  <v-btn
                    color="red darken-1"
                    text
                    flat
                    @click="dialogDelete = false"
                  >
                    Cancel
                  </v-btn>

                  <v-btn
                    color="green darken-1"
                    text
                    flat
                    @click="deleteItem(deleteItemRecord)"
                  >
                    Ok
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-data-table
              :loading="loading"
              :headers="headers"
              :items="DataList"
              :rows-per-page-items="rowsAmount"
              :search="search"
              dense
              loading-text="Loading... Please wait"
              class="elevation-1"
            >
              <!-- change table header background and text color(or other properties) -->
              <template
                slot="headerCell"
                slot-scope="{ header }"
              >
                <span
                  class="subheading font-weight-light text-general text--darken-3"
                  v-text="header.text"
                />
              </template>
              <template v-slot:items="props">
                <td class="justify-center ">
                  <v-icon
                    medium
                    class="mr-2"
                    @click="editItem(props.item)">edit
                  </v-icon>
                  <v-icon
                    medium
                    @click="dialogDeleteShow(props.item)">delete
                  </v-icon>
                </td>
                <td>{{ props.item.name }}</td>
                <td>{{ props.item.desc }}</td>
                <td>{{ props.item.opsMultiplier }}</td>
                <td>{{ props.item.opsAddition }}</td>
                <td>{{ props.item.discMax }}</td>
                <td>{{ props.item.lastUpdateBy }}</td>
                <td>{{ toStringDate(props.item.lastUpdateDate) }}</td>
              </template>
            </v-data-table>
            <v-snackbar
              v-model="snack"
              :timeout="5000"
              :color="snackColor">
              {{ snackText }}
              <v-btn
                flat
                @click="snack = false">Close
              </v-btn>
            </v-snackbar>
          </material-card>
        </div>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
  import displayFormatterMixins from '../../../mixins/displayFormatterMixins'
  import jsonCurrency from '../../../i18n/Currencies.json'

  export default {
    mixins: [displayFormatterMixins],
    data: () => ({
      currencyList: jsonCurrency,
      snack: false,
      valid: false,
      lazy: false,
      snackColor: '',
      snackText: '',
      rules: {
        required: value => !!value || 'Required.',
        max50chars: value => !value || value.length <= 50 || 'Max 50 characters',
        number: value => !isNaN(value) || 'Must be numeric'
      },
      pagination: {},
      DataList: [],
      totalRows: 0,
      checkboxEnabled: true,
      rowsAmount: [5, 20, 50, 100],
      dialog: false,
      dialogDelete: false,
      deleteItemRecord: {},
      resetRecord: {},
      loading: true,
      search: '',
      headers: [
        { text: '--Actions--', value: 'actions', sortable: false },
        { text: 'Name', value: 'name' },
        { text: 'Description', value: 'desc' },
        { text: '1st Formula (x)', value: 'opsMultiplier' },
        { text: '2nd Formula (+-)', value: 'opsAddition' },
        { text: 'Disc Max (%)', value: 'discMax' },
        { text: 'Update By', value: 'lastUpdateBy' },
        { text: 'Update Date Time', value: 'lastUpdateDate' }
      ],
      roles: [],
      editedIndex: -1,
      editedItem: {
        id: null,
        name: '',
        desc: '',
        opsAddition: '',
        opsMultiplier: '',
        discMax: ''
      },
      defaultItem: {
        id: null,
        name: '',
        desc: '',
        opsAddition: 0,
        opsMultiplier: 1,
        discMax: ''
      }
    }),
    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
      }
    },

    watch: {
      dialog (val) {
        val || this.close()
      }
    },
    // called when page is created before dom
    created () {
      this.getDatatable()
    },

    methods: {
      async getDatatable () {
        try {
          let response = await this.$http.get('/api/pricerule?ps=15&so=name')
          this.DataList = response.data.content
          this.totalRows = response.data.totalElements
        } catch (error) {
          console.log(error)
        }
      },

      dialogDeleteShow (data) {
        this.dialogDelete = true
        this.deleteItemRecord = data
      },

      // object.assign fills in the empty object with the properties of item
      editItem (item, dbox = true) {
        this.editedIndex = this.DataList.indexOf(item)
        item.isEnabled = this.checkboxEnabled
        this.editedItem = Object.assign({}, item)
        this.dialog = dbox
      },

      callTableAction (item, endpoint, method) {
        let tableItem = this.editedItem
        this.$store.dispatch('updateTableItem', { endpoint, tableItem, method })
          .then((response) => this.saveInline())
          .catch(error => {
            console.log(error)
            this.cancelInline()
          })
      },

      deleteItem (rec) {
        let endpoint = `api/customer/${rec.id}`
        let method = 'delete'
        let s = {}
        this.DataList.splice(this.DataList.indexOf(rec), 1)
        this.$store.dispatch('updateTableItem', { endpoint, s, method })
          .then((response) => this.deleteInline())
          .catch(error => {
            console.log(error)
            this.cancelInline()
          })
        this.dialogDelete = false
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      save () {
        if (!this.$refs.form.validate()) {
          console.log('validation fail direct')
        }
        if (this.$refs.form.validate()) {
          console.log('validation success')
        }
        if (this.editedIndex > -1) {
          Object.assign(this.DataList[this.editedIndex], this.editedItem)
          let tableItem = this.editedItem
          let endpoint = `api/pricerule/${this.editedItem.id}`
          let method = 'patch'
          this.$store.dispatch('updateTableItem', { endpoint, tableItem, method })
            .then((response) => this.saveInline())
            .catch(error => {
              console.log(error)
              this.cancelInline()
            })
        } else {
          let tableItem = this.editedItem
          this.DataList.push(this.editedItem)
          let endpoint = `api/pricerule`
          let method = 'post'
          this.$store.dispatch('updateTableItem', { endpoint, tableItem, method })
            .then((response) => {
              this.getDatatable()
            })
            .catch(error => {
              console.log(error)
              this.cancelInline()
            })
        }
        this.close()
      },
      // toasts/snackbar messages for actions
      saveInline () {
        this.snack = true
        this.snackColor = 'success'
        this.snackText = 'Data saved/updated'
      },
      cancelInline () {
        this.snack = true
        this.snackColor = 'error'
        this.snackText = 'Canceled'
      },
      deleteInline () {
        this.snack = true
        this.snackColor = 'success'
        this.snackText = 'Data removed'
      },
      reset () {
        this.snack = true
        this.snackColor = 'success'
        this.snackText = 'Data reset to default'
      },
      openInline () {
        this.snack = true
        this.snackColor = 'info'
        this.snackText = 'Dialog opened'
      },
      closeInline () {
        console.debug('Dialog closed')
      }
    }
  }
</script>

<style>
  table.v-table thead tr {
    color: red !important;
  }

  tbody tr:nth-of-type(odd) {
    background-color: rgba(0, 0, 0, .05);
  }
</style>
